<template>
  <v-card
    ref="listRoot"
    class="ma-0 app-list-page"
    :class="{
      'app-list-page--fixed': !isMobile && !mobileShow,
    }"
    width="100%"
    style="height: auto"
    elevation="2"
  >
    <v-app-bar
      ref="listToolbar"
      flat
      class="my-0 app-list-toolbar"
      :class="!isMobile && !mobileShow ? 'px-2 mb-0 py-0' : 'mb-6 py-1 px-2'"
      dense
      :height="!isMobile && !mobileShow ? 40 : 30"
    >
      <v-toolbar-title
        class="app-list-toolbar__title"
        :class="!isMobile && !mobileShow ? 'me-4' : 'mt-4 me-4'"
      >{{
        $t("productPerEntrepotList")
      }}</v-toolbar-title>
      <div
        v-if="!isMobile && !isTablet"
        class="app-list-toolbar__search"
        style="width: 230px"
      >
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
          hide-details
        />
      </div>
      <v-spacer />
      <v-btn
        v-if="selected.length > 0 && !isMobile"
        outlined
        @click="deletDialog = true"
        class="mt-4 ms-2"
        color="pink"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t("remove") }}
        </p>
        <v-icon> mdi-trash-can-outline </v-icon>
      </v-btn>
      <v-menu offset-y>
        <template v-slot:activator="{ attrs, on }">
          <v-btn
            outlined
            class="mt-4 px-1 ms-2"
            color="grey darken-2"
            height="32"
            v-bind="attrs"
            v-on="on"
            style="min-width: 35px !important; padding: 0 !important"
          >
            <!-- <p class="mb-0 me-2">
              {{$t('more')}}
            </p> -->
            <v-icon> mdi-dots-vertical </v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <log
            v-if="
              $store.state.permissions && $store.state.permissions.includes('logList')
            "
            ref="logRef"
            :type-prop="typeForm"
            :listProp="true"
            mode-prop="button"
          />
          <v-list-item v-if="isMobile || isTablet" link @click="getItems">
            <v-list-item-icon>
              <v-icon>mdi-refresh</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('refresh')" />
          </v-list-item>
          <v-list-item v-if="isMobile || isTablet" link @getAllRows="getAllRows">
            <export-excel
              ref="refExcel"
              :data="excelItems"
              worksheet="abriron.com"
              name="data.xls"
              type="xls"
              class="float-left d-flex"
              :title="$store.state.abrName"
              :total-prop="pageCount"
              :page-prop="excelPage"
              @getAllRows="getAllRows"
            >
              <v-list-item-icon>
                <v-icon>mdi-file-excel-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="$t('excel')" />
            </export-excel>
          </v-list-item>
          <v-list-item v-if="isMobile || isTablet" link @click="printDialog = true">
            <v-list-item-icon>
              <v-icon>mdi-printer-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('print')" />
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="getItems"
        class="mt-4 px-1 ms-2"
        color="grey darken-2"
        height="32"
        @shortkey="getItems"
        v-shortkey="['f5']"
        style="min-width: 35px !important; padding: 0 !important"
      >
        <!-- <p class="mb-0 me-2">
          {{$t('refresh')}}
        </p> -->
        <v-icon> mdi-refresh </v-icon>
      </v-btn>
      <export-excel
        v-if="!isMobile && !isTablet"
        ref="refExcel"
        :data="excelItems"
        worksheet="abriron.com"
        name="data-ai.xls"
        type="xls"
        class="float-left"
        :title="$store.state.abrName"
        :total-prop="pageCount"
        :page-prop="excelPage"
        @getAllRows="getAllRows"
      >
        <v-btn outlined class="mt-4 ms-2" color="grey darken-2 " height="32">
          <p class="font-weight-thin mb-0 me-2">
            {{ $t("excel") }}
          </p>
          <v-icon> mdi-file-excel-outline </v-icon>
        </v-btn>
      </export-excel>
      <v-btn
        outlined
        @click="filter = true"
        class="mt-4 ms-2"
        color="grey darken-2 "
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t("filter") }}
        </p>
        <v-icon> mdi-filter-outline </v-icon>
      </v-btn>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="printDialog = true"
        class="mt-4 ms-2"
        color="grey darken-2"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t("print") }}
        </p>
        <v-icon> mdi-printer-outline </v-icon>
      </v-btn>
    </v-app-bar>
    <p
      v-if="isMobile || isTablet || mobileShow"
      class="mb-0 mr-2"
      style="font-size: 10px"
    >({{ $t("perEntrepotContent") }})</p>
    <v-row
      v-if="isMobile || isTablet"
      class="mx-0"
      :class="{ 'mt-1': isMobile || isTablet }"
    >
      <v-col class="mb-4 px-2" cols="12">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </v-col>
    </v-row>
    <v-row v-if="isMobile || isTablet || mobileShow">
      <v-col cols="12" class="pt-3">
        <v-chip-group mandatory active-class="primary--text">
          <v-chip label outlined>
            {{ $t("remain") }}
            {{ $store.state.currency.name }}ی
            {{ $t("product") }}
            <span v-if="productEntrepot">
              <span
                v-for="(item, i) in productEntrepot"
                :key="i"
                style="background-color: #0066ff; border-radius: 2px; color: #fff"
                class="mr-1 pa-1"
              >
                {{ item.name }}
              </span>
            </span>
            &nbsp;در
            {{ $t("entrepot") }}
            <span v-if="entrepot">
              <span
                v-for="(item, i) in entrepot"
                :key="i"
                style="background-color: #0066ff; border-radius: 2px; color: #fff"
                class="mr-1 pa-1"
              >
                {{ item.name }}
              </span>
            </span>
            <span style="direction: ltr"
              >{{ global?.summary?.total_balance_value }} :
            </span>
          </v-chip>
          <v-chip label outlined>
            {{ $t("remain") }}
            {{ $t("some") }}ی
            {{ $t("product") }}
            <span v-if="productEntrepot">
              <span
                v-for="(item, i) in productEntrepot"
                :key="i"
                style="background-color: #0066ff; border-radius: 2px; color: #fff"
                class="mr-1 pa-1"
              >
                {{ item.name }}
              </span>
            </span>
            &nbsp;در
            {{ $t("entrepot") }}
            <span v-if="entrepot">
              <span
                v-for="(item, i) in entrepot"
                :key="i"
                style="background-color: #0066ff; border-radius: 2px; color: #fff"
                class="mr-1 pa-1"
              >
                {{ item.name }}
              </span>
            </span>
            <span> : {{ global?.summary?.total_balance_count }}</span>
          </v-chip>
        </v-chip-group>
      </v-col>
    </v-row>
    <v-row ref="listSummary" class="mx-0 app-list-summary-row">
      <v-col
        v-show="!isMobile && !mobileShow"
        class="pa-0"
        cols="12"
        md="12"
      >
        <div class="app-list-summary-kpis">
          <div class="app-list-summary-kpi app-list-summary-kpi--gross">
            <span class="app-list-summary-kpi__icon app-list-summary-kpi__icon--green">
              <v-icon size="18" color="#43A047">mdi-cash-multiple</v-icon>
            </span>
            <div class="app-list-summary-kpi__body">
              <div class="app-list-summary-kpi__label">{{ $t("sumPriceRemain") }}</div>
              <div class="app-list-summary-kpi__value">
                {{ $numberFormat(global?.summary?.total_balance_value) }}
              </div>
              <div class="app-list-summary-kpi__unit">
                {{ $store.state.currency.name }}
              </div>
            </div>
          </div>
          <div class="app-list-summary-kpi">
            <span class="app-list-summary-kpi__icon app-list-summary-kpi__icon--blue">
              <v-icon size="18" color="#1E88E5">mdi-format-list-numbered</v-icon>
            </span>
            <div class="app-list-summary-kpi__body">
              <div class="app-list-summary-kpi__label">{{ $t("sumCount") }}</div>
              <div class="app-list-summary-kpi__value">
                {{ $numberFormat(global?.summary?.total_balance_count) }}
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-col ref="listTableCol" cols="12" class="px-2 app-list-table-col">
      <v-data-table
        v-if="headers"
        ref="listTable"
        v-column-resize="productEntrepotListColumnPlugins"
        v-column-drag="productEntrepotListColumnPlugins"
        v-column-pin="productEntrepotListColumnPlugins"
        :height="isMobile || mobileShow ? 323 : tableHeight"
        fixed-header
        v-model="selected"
        :headers="showHeaders"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        :page.sync="page"
        multi-sort
        dense
        :show-select="showSelect"
        item-key="id"
        class="mb-2 td-hide-border app-list-table main-table invoice-sell-table-scroll"
        :class="{
          'mb-0 app-list-table--dense': !isMobile && !mobileShow,
        }"
        :style="
          !isMobile && !mobileShow
            ? 'border: 1px solid #e3e3e3; border-radius: 2px'
            : 'border: 1px solid #e3e3e3; border-radius: 6px'
        "
        :footer-props="{
          showFirstLastPage: !mobileShow ? true : false,
          itemsPerPageOptions: [10, 25, 50, 100, 500],
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-plus',
          nextIcon: 'mdi-minus',
        }"
      >
        <template v-slot:item.actions="{ item }">
          <v-menu offset-y>
            <template v-slot:activator="{ attrs, on }">
              <v-btn color="primary" v-bind="attrs" icon v-on="on">
                <v-icon medium> mdi-dots-vertical </v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item link @click="turnover(item, null)">
                <v-list-item-icon>
                  <v-icon>mdi-recycle-variant</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('productTurnover')" />
              </v-list-item>
              <v-list-item link @click="turnoverCount(item, null)">
                <v-list-item-icon>
                  <v-icon>mdi-ballot-recount-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('productCountTurnover')" />
              </v-list-item>
              <v-list-item link @click="turnoverAmount(item, null)">
                <v-list-item-icon>
                  <v-icon>mdi-chart-gantt</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('productAmountTurnover')" />
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:item.user.name="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div v-if="item.user" color="primary" dark v-bind="attrs" v-on="on">
                {{ item.user.firstname }} {{ item.user.lastname }}
              </div>
            </template>
            <span>{{ item.time }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.product.order_point="{ item }">
          {{ item.product.order_point ? item.product.order_point : "ندارد" }}
        </template>
        <template v-slot:item.unit.name="{ item }">
          {{ item.unit ? item.unit.fame : "ندارد" }}
        </template>
        <template v-slot:item.product.group.name="{ item }">
          {{ item.product.group ? item.product.group.name : "ندارد" }}
        </template>
        <template v-slot:item.product.cat1.name="{ item }">
          {{ item.product.cat1 ? item.product.cat1.name : "ندارد" }}
        </template>
        <template v-slot:item.product.cat2.name="{ item }">
          {{ item.product.cat2 ? item.product.cat2.name : "ندارد" }}
        </template>
        <template v-slot:item.count_in="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-2"
                dark
                text
                small
                v-bind="attrs"
                style="padding: 12px 4px !important; justify-content: start"
                color="primary"
                v-on="on"
                @click="turnover(item)"
              >
                {{ item.count_in }}
              </v-btn>
            </template>
            <span>{{ $t("productTurnover") }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.price_in="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-2"
                dark
                text
                small
                v-bind="attrs"
                style="padding: 12px 4px !important; justify-content: start"
                color="primary"
                v-on="on"
                @click="turnover(item)"
              >
                {{
                  item?.price_in != null
                    ? $numberFormat(
                        Number(item.price_in).toFixed($store.state.currency.decimal)
                      )
                    : ""
                }}
              </v-btn>
            </template>
            <span>{{ $t("productTurnover") }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.price_out="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-2"
                dark
                text
                small
                v-bind="attrs"
                style="padding: 12px 4px !important; justify-content: start"
                color="primary"
                v-on="on"
                @click="turnover(item)"
              >
                {{
                  item?.price_out != null
                    ? $numberFormat(
                        Number(item.price_out).toFixed($store.state.currency.decimal)
                      )
                    : ""
                }}
              </v-btn>
            </template>
            <span>{{ $t("productTurnover") }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.sum_price="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-2"
                dark
                text
                small
                v-bind="attrs"
                style="padding: 12px 4px !important; justify-content: start"
                color="primary"
                v-on="on"
                @click="turnover(item)"
              >
                {{
                  item?.price_in != null && item?.price_out != null
                    ? $numberFormat(
                        (Number(item.price_in) - Number(item.price_out)).toFixed(
                          $store.state.currency.decimal
                        )
                      )
                    : ""
                }}
              </v-btn>
            </template>
            <span>{{ $t("productTurnover") }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.count_out="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-2"
                dark
                text
                small
                v-bind="attrs"
                style="padding: 12px 4px !important; justify-content: start"
                color="primary"
                v-on="on"
                @click="turnover(item)"
              >
                {{ item.count_out ? item.count_out : 0 }}
              </v-btn>
            </template>
            <span>{{ $t("productTurnover") }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.count_remain="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-2"
                dark
                text
                small
                v-bind="attrs"
                style="padding: 12px 4px !important; justify-content: start"
                color="primary"
                v-on="on"
                @click="turnover(item)"
              >
                <!-- {{ 
                (+(item.count_in ? $numberFormat(item.count_in, 3) : 0) - 
                +(item.count_out ? $numberFormat(item.count_out, 3) : 0)) 
                }} -->
                <!-- {{ $numberFormat(+(item.count_in ?? 0) - +(item.count_out ?? 0)) }} -->
                {{ Math.trunc((+(item.count_in ?? 0) - +(item.count_out ?? 0)) * 1000) / 1000 }}
                <!-- {{ item.count ? item.count : 0 }} -->
              </v-btn>
            </template>
            <span>{{ $t("productTurnover") }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.price="{ item }">
          <a @click="edit(item)">
            {{ $numberFormat(parseFloat(item.price)) }} {{ $store.state.currencySymbol }}
          </a>
        </template>
        <template v-slot:item.name="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                color="primary"
                text
                small
                v-on="on"
                @click="edit(item)"
              >
                {{ item.name }}
              </v-btn>
              <v-chip v-if="item.status != 'active'" outlined color="pink" small>
                {{ $t("deactive") }}
              </v-chip>
            </template>
            <span>{{ $t("edit") }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.id="{ item }">
          <a @click="edit(item)">
            {{ item.id }}
          </a>
        </template>
        <template v-slot:item.row="{ item }">
          <a @click="edit(item)">
            {{ parseInt(items.indexOf(item)) + parseInt(from) }}
          </a>
        </template>
        <template v-slot:item.product.tags="{ item }">
          <div class="pt-1">
            <v-chip
              v-for="(tag, index) in item.product.tags"
              :key="index"
              :color="tag.color"
              label
              small
              style="margin-left: 1px; margin-right: 1px"
              class="px-1 mb-1"
              @click="edit(item)"
            >
              <span class="px-1 white--text">
                {{ tag.text }}
              </span>
            </v-chip>
          </div>
        </template>
        <template v-slot:item.time="{ item }">
          {{ item.time }}
        </template>
        <template v-slot:footer.prepend>
          <!-- Desktop fixed viewport: note sits in the totals bar above pagination -->
          <div
            v-if="!isMobile && !mobileShow"
            class="app-list-page-totals"
          >
            <span class="app-list-page-totals__item">
              <span class="app-list-page-totals__val">
                ({{ $t("perEntrepotContent") }})
              </span>
            </span>
          </div>
          <v-col
            v-show="!isMobile"
            cols="1"
            class="pa-0 app-list-goto-page"
            :class="{
              'app-list-goto-page--compact': !isMobile && !mobileShow,
            }"
            :style="
              !isMobile && !mobileShow ? null : 'margin-top: -10px'
            "
          >
            <!-- Flat glass: no border/shadow — bg via inline so footer CSS cannot override -->
            <div
              class="app-list-goto-page__box"
              :style="
                !isMobile && !mobileShow
                  ? {
                      height: '24px',
                      padding: '0 8px',
                      borderRadius: '4px',
                      backgroundColor: 'rgba(120, 130, 140, 0.12)',
                      border: 'none',
                      boxShadow: 'none',
                      backdropFilter: 'blur(10px)',
                      WebkitBackdropFilter: 'blur(10px)',
                    }
                  : null
              "
            >
              <span
                v-if="!isMobile && !mobileShow"
                class="app-list-goto-page__label"
              >{{ $t("goToPage") }}</span>
              <v-text-field
                v-model.number="page"
                :label="
                  !isMobile && !mobileShow ? undefined : $t('goToPage')
                "
                min="1"
                :max="pageCount"
                type="number"
                :outlined="isMobile || isTablet || mobileShow"
                :solo="!isMobile && !mobileShow"
                :flat="!isMobile && !mobileShow"
                :height="!isMobile && !mobileShow ? 20 : 32"
                hide-details
                hide-spin-buttons
                dense
                :suffix="' / ' + pageCount"
                class="app-list-goto-page__field"
              />
            </div>
          </v-col>
        </template>
      </v-data-table>
    </v-col>
    <v-row />
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="printDialog"
      width="70%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="printDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("print") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <print
            :header-prop="showHeaders"
            :items-prop="items"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="filter"
      width="70%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="filter = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("filter") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col md="4">
            <autocomplete
              v-model="entrepot"
              :title="$t('entrepot')"
              type="entrepot"
              :multiple="true"
              :filter="true"
              :spCurrency="true"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="productStatus"
              :label="$t('status')"
              :items="productStatusItems"
              height="30"
              dense
              outlined
              multiple
              clearable
              item-value="value"
              item-text="text"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="inventoryStatus"
              :label="$t('inventoryStatus')"
              :items="inventoryStatusItems"
              height="30"
              dense
              outlined
              clearable
              item-value="value"
              item-text="text"
            />
          </v-col>
          <v-col cols="12" md="4">
            <tag v-model="tag" />
          </v-col>
          <v-col md="4">
            <autocomplete
              v-model="group"
              :title="$t('main-group')"
              type="productGroup"
              :data="JSON.stringify({ parent: null, type: 'group' })"
              :multiple="true"
              :filter="true"
            />
          </v-col>
          <v-col md="4">
            <autocomplete
              v-model="cat1"
              :title="$t('other-group')"
              type="productGroup"
              :data="JSON.stringify({ parent: null, type: 'category' })"
              :multiple="true"
              :filter="true"
            />
          </v-col>
          <v-col md="4">
            <autocomplete
              v-model="cat2"
              title="category"
              type="productGroup"
              :data="JSON.stringify({ parent: null, type: 'subcategory' })"
              :multiple="true"
              :filter="true"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="selectedHeaders"
              :items="headers"
              label="Select Columns"
              height="30"
              dense
              outlined
              multiple
              return-object
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index < 2" small>
                  <span>{{ item.text }}</span>
                </v-chip>
                <v-chip v-if="index === 1" small>
                  <span>(+{{ selectedHeaders.length - 2 }} {{ $t("other") }})</span>
                </v-chip>
              </template>
            </v-select>
          </v-col>
          <v-col cols="12" md="4">
            <template>
              <v-text-field
                id="fromId"
                v-model="fromDate"
                :label="$t('from') + ' ' + $t('date')"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="fromDate"
                element="fromId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                auto-submit
                :color="
                  this.$vuetify.theme.themes[
                    this.$vuetify.theme.isDark ? 'dark' : 'light'
                  ].primary
                "
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col cols="12" md="4">
            <template>
              <v-text-field
                id="toId"
                v-model="toDate"
                :label="$t('until') + ' ' + $t('date')"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="toDate"
                element="toId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                :min="fromDate"
                auto-submit
                :color="
                  this.$vuetify.theme.themes[
                    this.$vuetify.theme.isDark ? 'dark' : 'light'
                  ].primary
                "
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col cols="12" md="4">
            <autocomplete
              v-model="branch"
              title="branch"
              type="branch"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col md="4">
            <autocomplete
              v-model="productEntrepot"
              :title="$t('product')"
              type="product"
              :multiple="true"
              :filter="true"
              :spCurrency="true"
            />
          </v-col>
        </v-row>
        <v-row v-if="!isMobile && customFieldsPermission" class="mx-0">
          <custom-fields
            v-model="customFields"
            :value="customFields"
            type-prop="productCustomFields"
            :multiple="true"
            class="px-4"
          />
        </v-row>
        <v-card-actions class="px-3">
          <v-row class="ma-0 px-0">
            <v-col class="pa-0 py-3" cols="6">
              <v-btn class="mx-0" color="primary" @click="getItems">
                {{ $t("filter") }}
              </v-btn>
            </v-col>
            <v-col class="pa-0 py-3" cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left mx-0"
                @click="filter = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="deletDialog"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="deletDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img class="mx-auto" width="200" src="@/assets/stop.svg" />
        </v-col>
        <v-col class="mt-3 pr-7">
          <p class="mx-auto font-weight-medium">
            {{ $t("are-you-sure-delete-this-case") }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                v-if="selected.length > 0"
                color="primary"
                :loading="loading"
                @click="removegroup"
              >
                {{ $t("remove") }}
              </v-btn>
              <v-btn v-if="selected.length == 0" color="primary" @click="remove">
                {{ $t("remove") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--    upload dialog-->
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="uploadDialog"
      width="500"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="uploadDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col class="mt-0 pt-0 pr-7">
          <upload
            type-prop="product"
            :get-item="uploadDialog"
            @close="uploadDialog = false"
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </v-card>
</template>

<script>
import Print from "../../components/general/Print/Index";
import General from "../../../../Mixins/general";
import Upload from "../../components/general/upload/upload";
import customFields from "../../components/general/customFields/index.vue";
import {
  applyColumnSettings,
  loadColumnSettings,
} from "@/plugins/columnSettings/columnSettings";
import { reorderPinnedHeaders } from "@/plugins/columnPin/columnPin";
export default {
  name: "ProductPerEntrepotList",
  components: {
    Snakbar: () => import("../../components/general/snakbar/snakbar"),
    Tag: () => import("../../components/general/Tag/tag"),
    autocomplete: () => import("../../components/general/patial/autocomplete"),
    customFields,
    Upload,
    Print,
  },
  mixins: [General],
  props: ["input", "type", "refId", "productProp", "mobileShow"],
  data: () => ({
    selected: [],
    excelItems: [],
    pageCount: 1,
    page: 1,
    customFields: null,
    inventoryStatus: null,
    inventoryStatusItems: null,
    fromDate: null,
    toDate: null,
    group: null,
    cat1: null,
    cat2: null,
    entrepot: null,
    registerar: null,
    selectedHeaders: [],
    uploadDialog: false,
    printDialog: false,
    deletDialog: false,
    filter: false,
    productStatus: null,
    productStatusItems: null,
    model: null,
    from: 1,
    taskDialog: null,
    tag: null,
    temp: null,
    deleteItem: null,
    sellStatus: null,
    items: [],
    sortBy: [],
    dialog: null,
    timer: 0,
    totalItems: 0,
    snakbar: false,
    typeForm: null,
    taskId: null,
    snakbarText: null,
    loading: true,
    options: {
      itemsPerPage: 5,
    },
    headers: null,
    listViewportObserver: null,
    listViewportRaf: null,
    // excelItems: [],
    search: null,
    productEntrepot: null,
    global: null,
  }),
  computed: {
    showSelect() {
      if (!this.isMobile) {
        return true;
      } else {
        return false;
      }
    },
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    isDesktopListViewport() {
      return !this.isMobile && !this.mobileShow;
    },
    productEntrepotListColumnPersistKey() {
      return (
        "product-per-entrepot-list-columns-" +
        (this.$route.name || "productPerEntrepotList")
      );
    },
    productEntrepotListLockedColumns() {
      // Fixed sticky block: select + actions + row (no unpin/drag)
      var locked = ["actions", "row"];
      return this.showSelect ? ["__select"].concat(locked) : locked;
    },
    productEntrepotListColumnPlugins() {
      // show-select inserts a leading checkbox <th>; pad visibleHeaders so
      // pin/resize/drag index mapping stays aligned with thead cells.
      var selectHeader = {
        value: "__select",
        text: "",
        width: 32,
        sortable: false,
        pinned: false,
        originalIndex: -1,
      };
      var visible = this.showSelect
        ? [selectHeader].concat(this.showHeaders || [])
        : this.showHeaders || [];
      return {
        headers: this.headers,
        visibleHeaders: visible,
        locked: this.productEntrepotListLockedColumns,
        anchor: "row",
        minWidth: 60,
        persistKey: this.productEntrepotListColumnPersistKey,
      };
    },
    showHeaders() {
      var app = this;
      return this.headers.filter(function (s) {
        if (app.typeForm === "service") {
          if (s.value === "stock" || s.value === "order_point") {
          } else {
            return app.selectedHeaders.includes(s);
          }
        } else {
          return app.selectedHeaders.includes(s);
        }
      });
    },
  },
  watch: {
    refId(val, oldVal) {
      // this.items = []
      this.getItems();
    },
    model() {
      this.$emit("input", this.model);
    },
    selected() {
      this.$emit("input", this.selected.text);
      if (this.selected.length > 0) {
        this.model = this.selected[0].text;
        this.temp = this.selected[0].text;
      }
      this.dialog = false;
    },
    search() {
      var app = this;
      app.loading = true;
      app.page = 1;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        app.getItems();
      }, 1000);
    },
    options: {
      handler() {
        var app = this;
        app.sortBy = [];
        app.options.sortBy.map(function (value, key) {
          const index = app.headers.findIndex((h) => h.value === value);
          app.sortBy.push(app.headers[index].table);
        });
        this.getItems();
      },
      deep: true,
    },
    sortBy() {
      const index = this.headers.findIndex((h) => h.value === this.sortBy);
      if (index > -1) {
        this.sortBy = this.headers[index].table;
      }
    },
    loading(val) {
      if (!val && this.isDesktopListViewport) {
        this.$nextTick(() => {
          this.bindListViewportObserver();
          this.scheduleDesktopTableHeightUpdate();
        });
      }
    },
    isDesktopListViewport(val) {
      if (val) {
        this.$nextTick(() => {
          this.updateDesktopTableHeight();
          this.bindListViewportObserver();
        });
      } else {
        this.unbindListViewportObserver();
        this.tableHeight = window.innerHeight - 245;
      }
    },
  },
  activated() {
    this.getItems();
    if (this.isDesktopListViewport) {
      this.$nextTick(() => {
        this.bindListViewportObserver();
        this.scheduleDesktopTableHeightUpdate();
      });
    }
  },
  beforeMount() {
    this.typeForm = "product";
    this.headers = [
      {
        text: this.$t("actions"),
        align: "start",
        sortable: false,
        value: "actions",
        width: 20,
      },
      {
        text: this.$t("row"),
        align: "start",
        sortable: false,
        value: "row",
        width: 20,
      },
      {
        text: this.$t("name"),
        sortable: true,
        value: "product.name",
        table: "products.name",
      },
      {
        text: this.$t("code"),
        sortable: true,
        value: "product.code",
        table: "products.code",
      },
      {
        text: this.$t("orderPoint"),
        sortable: false,
        value: "product.order_point",
      },
      {
        text: this.$t("unit"),
        sortable: false,
        value: "unit.name",
      },
      {
        text: this.$t("main-group"),
        sortable: false,
        value: "product.group.name",
      },
      {
        text: this.$t("other-group"),
        sortable: false,
        value: "product.cat1.name",
      },
      {
        text: this.$t("category"),
        sortable: false,
        value: "product.cat2.name",
      },
      {
        text: this.$t("tag"),
        sortable: false,
        value: "product.tags",
      },
      {
        text: this.$t("entrepot"),
        sortable: false,
        value: "entrepot.name",
      },
      {
        text: this.$t("sumInCount"),
        sortable: false,
        value: "count_in",
      },
      {
        text: this.$t("sumInPrice"),
        sortable: false,
        value: "price_in",
      },
      {
        text: this.$t("sumOutCount"),
        sortable: false,
        value: "count_out",
      },
      {
        text: this.$t("sumOutPrice"),
        sortable: false,
        value: "price_out",
      },
      {
        text: this.$t("sumCount"),
        sortable: false,
        value: "count_remain",
      },
      {
        text: this.$t("sumPriceRemain"),
        sortable: false,
        value: "sum_price",
      },
    ];
    this.productStatusItems = [
      {
        value: "active",
        text: this.$t("active"),
      },
      {
        value: "deactive",
        text: this.$t("deactive"),
      },
    ];
    this.inventoryStatusItems = [
      {
        value: ">",
        text: this.$t("available"),
      },
      {
        value: "=",
        text: this.$t("unavailable"),
      },
      {
        value: "<",
        text: this.$t("negetive"),
      },
      {
        value: "orderpoint",
        text: this.$t("orderpoint"),
      },
    ];
    if (this.input) {
      this.model = this.input;
    }
    this.headersMap = this.headers;
    this.selectedHeaders = this.headers;
    reorderPinnedHeaders(this.headers, {
      locked: this.productEntrepotListLockedColumns,
      anchor: "row",
    });
    this.loadProductEntrepotListColumnSettings();
  },
  mounted() {
    if (this.isDesktopListViewport) {
      this.$nextTick(() => {
        this.bindListViewportObserver();
        this.updateDesktopTableHeight();
        this.$nextTick(() => {
          this.bindListViewportObserver();
          this.scheduleDesktopTableHeightUpdate();
        });
      });
    }
  },
  deactivated() {
    this.unbindListViewportObserver();
  },
  beforeDestroy() {
    this.unbindListViewportObserver();
    if (this.listViewportRaf) {
      cancelAnimationFrame(this.listViewportRaf);
      this.listViewportRaf = null;
    }
  },
  methods: {
    resolveRefEl(ref) {
      if (!ref) return null;
      return ref.$el || ref;
    },
    onResize() {
      if (this.isDesktopListViewport) {
        this.updateDesktopTableHeight();
        return;
      }
      this.tableHeight = window.innerHeight - 245;
    },
    scheduleDesktopTableHeightUpdate() {
      if (this.listViewportRaf) cancelAnimationFrame(this.listViewportRaf);
      this.listViewportRaf = requestAnimationFrame(() => {
        this.listViewportRaf = null;
        this.updateDesktopTableHeight();
      });
    },
    updateDesktopTableHeight() {
      if (!this.isDesktopListViewport) {
        this.tableHeight = window.innerHeight - 245;
        return;
      }
      const rootEl = this.resolveRefEl(this.$refs.listRoot);
      const toolbarEl = this.resolveRefEl(this.$refs.listToolbar);
      const summaryEl = this.resolveRefEl(this.$refs.listSummary);
      const tableColEl = this.resolveRefEl(this.$refs.listTableCol);
      const tableEl = this.resolveRefEl(this.$refs.listTable);
      if (!rootEl || !tableColEl) {
        this.tableHeight = window.innerHeight - 245;
        return;
      }
      const rootStyle = window.getComputedStyle(rootEl);
      const rootPadding =
        (parseFloat(rootStyle.paddingTop) || 0) +
        (parseFloat(rootStyle.paddingBottom) || 0);
      const toolbarHeight = toolbarEl ? toolbarEl.offsetHeight : 0;
      let summaryHeight = 0;
      if (summaryEl) {
        const summaryVisible =
          summaryEl.offsetParent !== null || summaryEl.getClientRects().length > 0;
        if (summaryVisible) {
          const summaryStyle = window.getComputedStyle(summaryEl);
          summaryHeight =
            summaryEl.offsetHeight +
            (parseFloat(summaryStyle.marginTop) || 0) +
            (parseFloat(summaryStyle.marginBottom) || 0);
        }
      }
      const colStyle = window.getComputedStyle(tableColEl);
      const colPadding =
        (parseFloat(colStyle.paddingTop) || 0) +
        (parseFloat(colStyle.paddingBottom) || 0);
      const footerEl = tableEl ? tableEl.querySelector(".v-data-footer") : null;
      const footerHeight = footerEl ? footerEl.offsetHeight : 0;
      const tableStyle = tableEl ? window.getComputedStyle(tableEl) : null;
      const tableMargins = tableStyle
        ? (parseFloat(tableStyle.marginTop) || 0) +
          (parseFloat(tableStyle.marginBottom) || 0)
        : 0;
      const available =
        rootEl.clientHeight -
        rootPadding -
        toolbarHeight -
        summaryHeight -
        colPadding -
        footerHeight -
        tableMargins -
        3;
      this.tableHeight = Math.max(180, Math.floor(available));
    },
    bindListViewportObserver() {
      if (typeof ResizeObserver === "undefined") return;
      this.unbindListViewportObserver();
      const rootEl = this.resolveRefEl(this.$refs.listRoot);
      const summaryEl = this.resolveRefEl(this.$refs.listSummary);
      const tableColEl = this.resolveRefEl(this.$refs.listTableCol);
      const tableEl = this.resolveRefEl(this.$refs.listTable);
      const footerEl = tableEl ? tableEl.querySelector(".v-data-footer") : null;
      if (!rootEl && !summaryEl && !tableColEl) return;
      this.listViewportObserver = new ResizeObserver(() => {
        this.scheduleDesktopTableHeightUpdate();
      });
      if (rootEl) this.listViewportObserver.observe(rootEl);
      if (summaryEl) this.listViewportObserver.observe(summaryEl);
      if (tableColEl) this.listViewportObserver.observe(tableColEl);
      if (footerEl) this.listViewportObserver.observe(footerEl);
    },
    unbindListViewportObserver() {
      if (this.listViewportObserver) {
        this.listViewportObserver.disconnect();
        this.listViewportObserver = null;
      }
    },
    loadProductEntrepotListColumnSettings() {
      var app = this;
      if (!app.headers || !app.headers.length) return;
      loadColumnSettings(app, app.productEntrepotListColumnPersistKey).then(function (snapshot) {
        if (!snapshot || !snapshot.length) return;
        applyColumnSettings(app.headers, snapshot, {
          locked: app.productEntrepotListLockedColumns,
          anchor: "row",
        });
        app.$forceUpdate();
      });
    },
    openDeleteDialog(item) {
      this.deleteItem = item;
      this.deletDialog = true;
    },
    openUploadDialog(item) {
      this.uploadDialog = true;
    },
    openTaskDialog(item) {
      this.refId = item.rel_id;
      this.taskId = item.id;
      this.taskDialog = true;
    },
    isEnabled(slot) {
      return this.enabled === slot;
    },
    edit(item) {
      this.$router.push({ name: "ProductEdit", params: { id: item.id } });
    },
    turnover(item) {
      this.$router.push({
        name: "productTurnoverSingle",
        params: {
          id: item.product.id,
          entrepotProp: item.entrepot_id,
          tabName: item.product.name,
        },
      });
    },
    turnoverCount(item, entrepot) {
      this.$router.push({
        name: "productCountTurnover",
        params: { productProp: item, entrepotProp: entrepot },
      });
    },
    turnoverAmount(item, entrepot) {
      this.$router.push({
        name: "productAmountTurnover",
        params: { productProp: item, entrepotProp: entrepot },
      });
    },
    getItems() {
      var app = this;
      app.loading = true;
      app.filter = false;
      var productId = app.productProp ? app.productProp.id : null;
      productId = this.$route.params.id ? this.$route.params.id : productId;
      app.$axios
        .get(this.$endpoint + "productsreport", {
          params: {
            report: "perEntrepot",
            inventoryStatus: app.inventoryStatus,
            productId: productId,
            entrepot: app.entrepot?.map((item) => item.id),
            productIds: app.productEntrepot?.map((item) => item.id),
            customFields: app.customFields,
            group: app.group,
            cat1: app.cat1,
            cat2: app.cat2,
            fromDate: app.fromDate,
            toDate: app.toDate,
            registerar: app.registerar,
            branch: app.branch,
            search: app.search,
            page: app.allRows ? app.excelPage : app.options.page,
            refId: app.refId,
            type: app.type,
            sortBy: app.sortBy,
            status: app.productStatus,
            options: app.options,
            tag: app.tag,
            typeForm: app.typeForm,
          },
        })
        .then((res) => {
          this.global = res.data;
          res = res.data;
          if (!app.allRows) {
            app.items = res.data;
            app.totalItems = res.total;
            app.pageCount = res.last_page;
            app.from = res.from;
            app.creatExcelData(res.data);
          } else {
            app.generateExcellForAllData(res.data, res.last_page);
          }
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    remove() {
      var app = this;
      if (!app.deleteItem) return false;
      app.loading = true;
      app.$axios
        .delete(this.$endpoint + "products/" + this.deleteItem.id)
        .then((res) => {
          res = res.data;
          app.deletDialog = false;
          app.deleteItem = null;
          app.getItems();
        })
        .catch((err) => {
          this.deletDialog = false;
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    removegroup() {
      var app = this;
      app.loading = true;
      var selected = [];
      app.selected.map(function (value, key) {
        selected.push({ id: value.id });
      });
      app.$axios
        .get(this.$endpoint + "products", {
          params: {
            deleteItems: selected,
          },
        })
        .then((res) => {
          res = res.data;
          app.deletDialog = false;
          app.deleteItem = null;
          app.selected = [];
          app.getItems();
        })
        .catch((err) => {
          this.deletDialog = false;
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    creatExcelData(data, type = "page") {
      var app = this;
      if (type === "page") {
        app.excelItems = [];
      }
      data.map(function (d) {
        app.excelItems.push({
          type: app.$t(d.type),
          id: d.product.id,
          uid: d.product.uid,
          name: d.product.name,
          code: d.product.code,
          barcode: d.product.barcode,
          branch: app.branch,
          order_point: d.product.order_point,
          entrepot: d.entrepot ? d.entrepot.name : "",
          unit: d.unit ? d.unit.fame : "",
          count_in: +d.count_in,
          count_out: +d.count_out,
          count_remain: +d.count_in - +d.count_out,
          price_in: +d.price_in,
          price_out: +d.price_out,
          price_remain: +d.price_in - +d.price_out,
          user: d.user ? d.user.name : "",
        });
      });
    },
  },
};
</script>

<style scoped>
::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  white-space: nowrap;
}
::v-deep
  .v-text-field--outlined.v-input--dense.v-text-field--outlined
  > .v-input__control
  > .v-input__slot {
  min-height: 32px !important;
}
</style>
